import * as React from "react";
import XDiv from "../../core/XDiv";
import {
  IXGUIFieldBase,
  TOnChange,
} from "../../../utils/interfaces/gui/fields.interfaces";

import { Button, Stack } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useXoraiaValue } from "../../../hooks/useXoraia";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

const compareProps = (prevProps: any, nextProps: any) => {
  // return isEqual(prevProps, nextProps);
  return prevProps.currentValue === nextProps.currentValue;
};

interface XGUITextFieldProps extends IXGUIFieldBase {
  onChange: TOnChange<string>;
  currentValue: string;
  type: "image" | "video";
}

const XGUITextField: React.FC<XGUITextFieldProps> = React.memo(
  ({ field, currentValue, onChange, type = "image" }) => {
    const { uploadFile } = useXoraiaValue();

    const bp = useBreakpoint();

    const id = `XGUI-FIELD-${field.name}`;

    const url = currentValue ?? field.defaultValue;

    const uploader = async (file: File) => {
      try {
        const _previewUrl = URL.createObjectURL(file);

        // ADDING PREVIEW URL FIRST
        onChange(_previewUrl, field.name, bp);

        if (uploadFile) {
          const _url = await uploadFile(file, type);

          // THEN ADD THE FINAL URL
          onChange(_url, field.name, bp);
        }
      } catch (error) {
        console.error("ERROR", error);
      }
    };

    return (
      <XDiv className="XGUI-Field" key={field.name}>
        <label className="XGUI-Field-Label" htmlFor={id}>
          {field.label}
        </label>
        <Stack
          className="XGUI-Field-Control"
          direction="row"
          spacing={1}
          ml={1}
        >
          {url && (
            <Stack
              sx={{
                width: 30,
                height: 30,
                "& > span": {
                  display: "flex",
                  borderRadius: 1,
                },
              }}
              className="preview-image"
            >
              <img
                src={url}
                width={30}
                height={30}
                style={{ objectFit: "cover" }}
                loading="lazy"
              />
            </Stack>
          )}
          <Button
            variant="outlined"
            component="label"
            size="small"
            // disabled={disabled}
            color="primary"
            fullWidth
          >
            {url ? "Changer" : "Choisir une image"}
            <input
              hidden
              accept="image/*"
              multiple={false}
              type="file"
              onChange={async (e) => {
                if (e.target && e.target.files) {
                  const file = e.target.files[0];

                  if (file) await uploader(file);

                  // setUrl(_url);
                }
              }}
            />
          </Button>
          {url && (
            <Button
              className="clear-image"
              variant="outlined"
              size="small"
              // disabled={disabled}
              color="error"
              sx={{
                minWidth: 30,
                "& .close-icon.MuiSvgIcon-root": { color: "inherit" },
              }}
              onClick={() => {
                // setUrl(null);
              }}
            >
              <Close
                className="close-icon"
                sx={{ fontSize: "inherit", color: "inherit" }}
              />
            </Button>
          )}
        </Stack>
        {/* <input
          id={id}
          className="XGUI-Field-Input XGUI-Field-Control"
          placeholder={field.placeholder ?? field.label}
          value={currentValue ?? field.defaultValue}
          onChange={(e) => {
            onChange(e.target.value, field.name);
          }}
          type={type}
          min={0}
        /> */}
      </XDiv>
    );
  },
  compareProps
);

export default XGUITextField;
